var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Purchase Price"}},[_c('input-money',{attrs:{"name":"purchase_price","read_only":_vm.read_only},model:{value:(_vm.price),callback:function ($$v) {_vm.price=$$v},expression:"price"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }